// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PHighlightOutlinedSvg from "@fishx/icons-svg/es/asn/PHighlightOutlined";
import FishxIcon from '../components/FishxIcon';

var PHighlightOutlined = function PHighlightOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PHighlightOutlinedSvg
  }));
};

PHighlightOutlined.displayName = 'PHighlightOutlined';
export default React.forwardRef(PHighlightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PHighlightOutlined.js
// module id = 3445
// module chunks = 0